// 学生端独立布局 - 使用单一根路由包含所有子路由
const StudentLayout = () => import("@/views/user-student/layout/index.vue")

// console.log("📚 学生端路由模块已加载")

export default {
  path: "/student",
  name: "Student",
  component: StudentLayout,
  redirect: "/student/dashboard",
  meta: {
    title: "学生端",
    showLink: false,
    rank: -100 // 高优先级，确保在教师端路由之前
  },
  children: [
    {
      path: "dashboard",
      name: "StudentDashboard",
      component: () => import("@/views/user-student/index.vue"),
      meta: {
        title: "学生首页",
        showLink: true,
        icon: "ep:home-filled"
      }
    },
    {
      path: "exam",
      name: "StudentExam",
      component: () => import("@/views/user-student/exam/index.vue"),
      meta: {
        title: "参加考试",
        showLink: true,
        icon: "ep:document"
      }
    },
    {
      path: "exam/room/:id",
      name: "StudentExamRoom",
      component: () => import("@/views/user-student/exam/children/exam-room/index.vue"),
      meta: {
        title: "考试中",
        showLink: false
      }
    },
    {
      path: "exam/result",
      name: "StudentExamResult",
      component: () => import("@/views/user-student/exam/children/exam-result/index.vue"),
      meta: {
        title: "答题详情",
        showLink: false
      }
    },
    {
      path: "practice",
      name: "StudentPractice",
      component: () => import("@/views/user-student/practice/index.vue"),
      meta: {
        title: "练习自测",
        showLink: true,
        icon: "ep:edit"
      }
    },
    {
      path: "practice/room/:id",
      name: "StudentExerciseRoom",
      component: () => import("@/views/user-student/practice/children/exercise-room/index.vue"),
      meta: {
        title: "练习中",
        showLink: false
      }
    },
    {
      path: "practice/result",
      name: "StudentExerciseResult",
      component: () => import("@/views/user-student/practice/children/exercise-result/index.vue"),
      meta: {
        title: "练习详情",
        showLink: false
      }
    },
    {
      path: "review",
      name: "StudentReview",
      component: () => import("@/views/user-student/review/index.vue"),
      meta: {
        title: "错题复习",
        showLink: true,
        icon: "ep:document-copy"
      }
    },
    {
      path: "score",
      name: "StudentScore",
      component: () => import("@/views/user-student/score/index.vue"),
      meta: {
        title: "我的成绩",
        showLink: true,
        icon: "ep:trophy"
      }
    },
    {
      path: "score/detail/:id",
      name: "StudentScoreDetail",
      component: () => import("@/views/user-student/score/children/score-detail/index.vue"),
      meta: {
        title: "成绩详情",
        showLink: false
      }
    }
  ]
} satisfies RouteConfigsTable
